// extracted by mini-css-extract-plugin
export default {"icon":"CertificateStatus_icon__jikmL","green":"CertificateStatus_green__J0FhW","yellow":"CertificateStatus_yellow__yXtDN","red":"CertificateStatus_red__RRntq"};